import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
} from '@angular/fire/firestore';

export interface EventCounter {
  id?: string;
  shoutoutCount: number;
  kioskShoutoutCount: number;
  grossRevenue: number;
  netRevenue: number;
}

export const eventCounterConverter: FirestoreDataConverter<EventCounter> = {
  toFirestore(eventCounter: EventCounter): DocumentData {
    return {
      ...eventCounter,
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot): EventCounter {
    const data = snapshot.data();
    return {
      id: snapshot.id,
      shoutoutCount: data['shoutoutCount'],
      kioskShoutoutCount: data['kioskShoutoutCount'],
      grossRevenue: data['grossRevenue'],
      netRevenue: data['netRevenue'],
    };
  },
};
